




import { Component, Vue, Prop, Watch } from "vue-property-decorator";
@Component
export default class ScrollToBottom extends Vue {
    @Prop({ type: Number })
    totalPages!: number;
    @Prop({ type: Number })
    page!: number;

    @Prop({ type: Boolean })
    isTax!: boolean;

    @Prop({ type: String, default: "select-bar-infinity" })
    listenClass!: string;

    pageCopy: number = this.page;
    @Watch("page")
    pageChange(val: number) {
        this.pageCopy = val;
    }

    mounted() {
        let listenedElement: HTMLElement = <HTMLElement>document.querySelector(`.${this.listenClass}`);
        listenedElement.addEventListener("wheel", this.scrollToBottom);
    }
    beforeDestroy() {
        let listenedElement: HTMLElement = <HTMLElement>document.querySelector(`.${this.listenClass}`);
        if (listenedElement != null) listenedElement.removeEventListener("wheel", this.scrollToBottom);
    }

    scrollToBottom() {
        let wrapDiv;
        if (this.listenClass != "select-bar-infinity") wrapDiv = <HTMLElement>document.querySelector(`.${this.listenClass}`);
        else wrapDiv = <HTMLElement>document.querySelector(`.${this.listenClass} .el-select-dropdown__wrap.el-scrollbar__wrap`);
        let wrapUl = <HTMLElement>document.querySelector(`.${this.listenClass} ul`);
        if (
            wrapUl.offsetHeight - wrapDiv.offsetHeight <=
            wrapDiv.scrollTop + 20
        ) {
            if (this.pageCopy <= this.totalPages) {
                this.pageCopy++;
                this.$emit("update:page", this.pageCopy);
                this.$emit("change")
            }
        }
    };
}
